import SaleUtils from '@/services/SaleUtils'
//
export default [
    {
        text: 'CODIGO INTERNO',
        value: 'internal_code',
    },
    {
        text: 'NOMBRE',
        value: 'name',
    },
    {
        text: 'ALIAS',
        value: 'alias_name',
    },
    {
        text: 'Precio Venta',
        value: 'sale_price_by_branch_office',
        format: 'currency',
        align: 'right',
        input: {
            reverse: true,
            disabled: true,
            type: 'currency-field',
        },
        width: '12%',
    },

    {
        text: 'costo',
        value: 'costPriceItem',
        format: 'currency',
        align: 'right',
        width: '10%',
    },

    {
        text: 'Nuevo Precio',
        value: 'new_sale_price',
        format: 'currency',
        align: 'right',
        input: {
            reverse: true,
            trigger: (ctx, props) => {
                props.item.gains_margin = SaleUtils.getNewMargin(props.item.new_sale_price,props.item.costPriceItem)
            },
            type: 'currency-field',
            // trigger: (ctx, props) => {
            //     props.item.discount =
            //         props.item.sale_price -
            //         parseInt(props.item.unit_price_discount)
            //     ctx.$forceUpdate()
            // },
        },
        width: '12%',
    },

    {
        text: 'margen',
        value: 'new_gain_margin',
        align: 'right',
        format: 'percentage',
        width: '10%',
    },
]
